import {
  SET_LOADING,
  SAVE_DATA,
  SET_FILTER,
  SET_ACTIVE_PAGE,
  VM_LOADING,
  BTN_LOADING,
  SET_VM_OPTIONS,
  SET_VM_SELECTED_OPTION,
} from './constants';

export function setLoading(isLoading) {
  return {
    type: SET_LOADING,
    isLoading,
  };
}

export function saveData(data) {
  return {
    type: SAVE_DATA,
    data,
  };
}

export function setFilter(filter) {
  return {
    type: SET_FILTER,
    filter,
  };
}

export function setActivePage(pageNumber) {
  return {
    type: SET_ACTIVE_PAGE,
    pageNumber,
  };
}

export function setDropdownLoading(loading) {
  return {
    type: VM_LOADING,
    loading,
  };
}

export function setVMOptions(options) {
  return {
    type: SET_VM_OPTIONS,
    options,
  };
}

export function setVMSelectedOptions(value) {
  return {
    type: SET_VM_SELECTED_OPTION,
    value,
  };
}

export function setButtonLoading(loading) {
  return {
    type: BTN_LOADING,
    loading,
  };
}



// WEBPACK FOOTER //
// ./src/Modules/Orders/actions.js